import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SocialIcons from "../Pages/Sections/SocialIcons";
import "./Footer.css";

const FOOTER_LINKS = [
  { path: "/About", text: "About" },
  { path: "/Services", text: "Services" },
  { path: "/Projects", text: "Projects" },
  { path: "/Contact", text: "Contact" },
];

function formatTime(date) {
  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

const Footer = () => {
  const [time, setTime] = useState(() => formatTime(new Date()));

  useEffect(() => {
    const id = setInterval(() => setTime(formatTime(new Date())), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <footer className="footer">
      <div className="container">
        {/* Call to action */}
        <div className="footer__cta-band">
          <div className="footer__cta-copy">
            <span className="eyebrow">Let&apos;s work together</span>
            <h2 className="footer__cta-title">
              Have a project or role in mind?
            </h2>
            <p className="footer__cta-text">
              I&apos;m open to new opportunities and collaborations — from
              systems engineering to full-stack builds.
            </p>
          </div>
          <div className="footer__cta-actions">
            <Link to="/Contact" className="btn btn-primary">
              Start a conversation →
            </Link>
            <a className="btn btn-ghost" href="mailto:danieloshinubi@gmail.com">
              danieloshinubi@gmail.com
            </a>
          </div>
        </div>

        {/* Main footer columns */}
        <div className="footer__main">
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <span className="footer__logo-mark">AO</span>
              Daniel Oshinubi
            </Link>
            <p className="footer__tagline">
              IT Systems Engineer &amp; Software Developer building reliable,
              modern digital experiences.
            </p>
            <SocialIcons />
          </div>

          <nav className="footer__nav" aria-label="Footer">
            <h4 className="footer__heading">Navigate</h4>
            <ul>
              {FOOTER_LINKS.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.text}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="footer__meta">
            <h4 className="footer__heading">Status</h4>
            <p className="footer__clock">
              <span className="footer__dot" /> Local time {time}
            </p>
            <p className="footer__available">Available for new projects</p>
          </div>
        </div>

        <div className="footer__bottom">
          <span>
            © {new Date().getFullYear()} Daniel Oshinubi. All rights reserved.
          </span>
          <span className="footer__built">Built with React</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
